import { action, observable, makeObservable } from 'mobx';
import _ from 'lodash';
import FilterRow from './FilterRow';

class MultiSelectFilterRow extends FilterRow {
  values = [];

  constructor(other) {
    super();

    makeObservable(this, {
      values: observable,
      add: action,
      remove: action
    });

    this.merge(other);
  }

  add(value) {
    this.values.push(value);
  }

  remove(value) {
    _.pull(this.values, value);
  }

  toJS(options = {}) {
    if (_.isEmpty(this.values) && !options.showEmptyValues) return [];

    const json = super.toJS();
    return [json];
  }
}

export default MultiSelectFilterRow;
